import { render } from "./CollectPaymentForm.vue?vue&type=template&id=58073c14"
import script from "./CollectPaymentForm.vue?vue&type=script&lang=js"
export * from "./CollectPaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__